import React, { useRef } from 'react';
import emailjs from 'emailjs-com';
import './contact.css'
import {MdOutlineMail} from 'react-icons/md'
import {MdOutlinePhoneIphone} from 'react-icons/md'
// import {RiMessengerLine} from 'react-icons/ri'
// import {BsWhatsapp} from 'react-icons/bs'

export default function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm("service_xsf5nv7","template_8c9zrlh", e.target, 'grMb9HZrYqtzGa8J5')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });

      e.target.reset();
  };

  return (
    <section id="contact">
      <h5>Get in touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineMail className="contact__option-icon" />
            <h4>Email</h4>
            <h5>trevor.moir@yahoo.ca</h5>
            <a href="mailto:trevor.moir@yahoo.ca" target="_blank" rel="noreferrer">Send a message</a>
          </article>
          <article className="contact__option">
            <MdOutlinePhoneIphone className="contact__option-icon" />
            <h4>Cell</h4>
            <h5>+1 (905) 616-4926</h5>
            <a href="tel:19056164926" target="_blank" rel="noreferrer">Call Me</a>
          </article>
          {/* <article className="contact__option">
            <RiMessengerLine className="contact__option-icon" />
            <h4>Messenger</h4>
            <h5>trevor.moir.1</h5>
            <a href="https://m.me/trevor.moir.1" target="_blank" rel="noreferrer">Send a message</a>
          </article> */}
          {/* <article className="contact__option">
            <BsWhatsapp className="contact__option-icon" />
            <h4>WhatsApp</h4>
            <h5>+19056164826</h5>
            <a href="https://api.whatsapp.com/send?phone=19056164926" target="_blank" rel="noreferrer">Send a message</a>
          </article> */}
        </div>

        <form rel={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder="Your Full Name" required />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea name="message" rows="7" placeholder="Your Message" required></textarea>
          <button type="submit" className="btn btn-primary">Send Message</button>
        </form>
      </div>
    </section>
  )
}
